window.addEventListener("beforeunload", function (event) {
    function showLoadingScreen() {
        $('.loading-overlay').show();
    }
    setTimeout(showLoadingScreen, 1000);
});

